<template>
    <div v-if="getPermission.opcockpiti.view || getPermission.opcockpito.view">

        <md-tabs md-sync-route class="operation-cockpit-tabs">
          <md-tab id="tab-inbound-appt" md-label="Inbound-Appt" to="/inboundCockpitNew/inboundAppt" v-if="getPermission.opcockpiti.view"></md-tab>
          <md-tab id="tab-inbound-scale" md-label="Inbound-CI" to="/inboundCockpitNew/inboundScale" v-if="getPermission.opcockpiti.view"></md-tab>
          <md-tab id="tab-inbound-tm" md-label="Inbound-SCALE" to="/inboundCockpitNew/inboundTM" v-if="getPermission.opcockpiti.view"></md-tab>
          <md-tab id="tab-ocReports" md-label="Reports" to="/inboundCockpitNew/ocReports" v-if="getPermission.opcockpito.view"></md-tab>
        </md-tabs>
        <router-view/>

    </div>

</template>

<style lang="scss">


  .operation-cockpit-tabs {
    .md-tabs-navigation {
      .md-theme-default {
        height: 30px;
      }
    }
  }
</style>


<script>
  import { mapGetters } from 'vuex';

  export default {
    data: () => ({}),
    computed: {
      ...mapGetters([
        'getPermission',
        'getMasterDataName',
      ]),
    },
  };

</script>



